export default () => _ref => {
  var type = _ref.type,
    key = _ref.key;
  if (typeof window.trac !== 'undefined' && typeof window.trac[type] === 'function') {
    window.trac[type](key);
  }
};